import React from 'react';
import { RotateCwIcon, TimerOffIcon, UsersIcon, UserMinusIcon } from 'lucide-react';
import { useProto } from '../../contexts/PrototypeContext';
import { Toggle } from '../shared/Toggle';
import { formatCountdown } from '../../utils/format';
const holdLabels = {
  none: 'None',
  reserved: 'Reserved',
  expired: 'Expired',
  released: 'Released',
  claimed: 'Claimed'
};
export function SystemStatePanel() {
  const {
    state,
    summary,
    holdRemainingMs,
    actions
  } = useProto();
  const {
    config,
    reservation
  } = state;
  const pct = summary.totalOpportunities ? summary.available / summary.totalOpportunities * 100 : 0;
  const simButtons = [{
    label: 'Another family takes the rest',
    Icon: UsersIcon,
    onClick: actions.claimRemaining,
    disabled: summary.available === 0
  }, {
    label: 'Release other carts’ holds',
    Icon: UserMinusIcon,
    onClick: actions.releaseOthers,
    disabled: state.otherReservations === 0
  }, {
    label: 'Expire my hold now',
    Icon: TimerOffIcon,
    onClick: actions.expireHold,
    disabled: reservation.status !== 'reserved'
  }, {
    label: 'Reload Volunteer Info page',
    Icon: RotateCwIcon,
    onClick: actions.reloadPage,
    disabled: state.view !== 'customer'
  }];
  return <section aria-labelledby="sys-title" className="mt-auto space-y-4 border-t border-proto-line bg-proto-hover/60 px-5 py-4" data-id="element-420" data-mp="3n72kklgtlyau">
      <div data-id="element-421" data-mp="3j6iqxrvghctg">
        <h2 id="sys-title" className="text-xs font-semibold text-proto-muted" data-id="element-422" data-mp="3j60uau4vswl0">Live system state</h2>
        <p className="mt-2 flex items-baseline gap-1.5 text-proto-ink" data-id="element-423" data-mp="2vfwqomrp0wu0">
          <span className="text-2xl font-semibold tabular-nums" data-id="element-424" data-mp="2qhlfa7lr2e9o">{summary.available}</span>
          <span className="text-xs text-proto-muted" data-id="element-425" data-mp="34gl4bgd6cv6d">of {summary.totalOpportunities} opportunities open to new customers</span>
        </p>
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-proto-line" aria-hidden="true" data-id="element-426" data-mp="2zfx8mhe03q5t">
          <div className="h-full rounded-full bg-proto-accent transition-[width] duration-200 ease-out" style={{
          width: `${pct}%`
        }} data-id="element-427" data-mp="jo9dmrijs7pn" />
        </div>
        <dl className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1 text-xs" data-id="element-428" data-mp="38jimqlcr1qla">
          <dt className="text-proto-muted" data-id="element-429" data-mp="3di26qg7s8sb0">Claimed</dt>
          <dd className="text-right tabular-nums text-proto-ink" data-id="element-430" data-mp="3dgr1sd2lpeib">{summary.roleClaimed + summary.unassignedClaims}</dd>
          <dt className="text-proto-muted" data-id="element-431" data-mp="3hkgnmurw5hzn">Other carts holding</dt>
          <dd className="text-right tabular-nums text-proto-ink" data-id="element-432" data-mp="3mhpbnbzq0g8t">{state.otherReservations}</dd>
          <dt className="text-proto-muted" data-id="element-433" data-mp="2ptiyu1snahjg">This customer</dt>
          <dd className="text-right text-proto-ink" data-id="element-434" data-mp="2tu2vz5d7xl5l">
            {holdLabels[reservation.status]}
            {reservation.status === 'reserved' && <span className="tabular-nums" data-id="element-435" data-mp="2ys4pylc6n4vu"> · {formatCountdown(holdRemainingMs)}</span>}
          </dd>
        </dl>
      </div>

      <div className="space-y-2" data-id="element-436" data-mp="33lh05qg47952">
        <h3 className="text-xs font-semibold text-proto-muted" data-id="element-437" data-mp="264ic8k98qjv9">Program incentives</h3>
        <label className="flex items-center justify-between gap-3 text-xs text-proto-ink" data-id="element-438" data-mp="262o11xnru64d">
          Volunteer Registration Discount
          <Toggle size="sm" checked={config.discountEnabled} onChange={v => actions.updateConfig({
          discountEnabled: v
        })} label="Volunteer Registration Discount" data-id="element-439" data-mp="23klxhxxukwjc" />
        </label>
        <label className="flex items-center justify-between gap-3 text-xs text-proto-ink" data-id="element-440" data-mp="1tlweg1u7t61i">
          Automated Coach Credit
          <Toggle size="sm" checked={config.coachCreditEnabled} onChange={v => actions.updateConfig({
          coachCreditEnabled: v
        })} label="Automated Coach Credit" data-id="element-441" data-mp="1pl2s3cwf7zaq" />
        </label>
      </div>

      <div className="space-y-1.5" data-id="element-442" data-mp="1ftzpg6nufc9c">
        <h3 className="text-xs font-semibold text-proto-muted" data-id="element-443" data-mp="1fsx228pqbry6">Simulate</h3>
        {simButtons.map(({
        label,
        Icon,
        onClick,
        disabled
      }) => <button key={label} type="button" onClick={onClick} disabled={disabled} className="flex w-full items-center gap-2 rounded-md border border-proto-line bg-white px-2.5 py-1.5 text-left text-xs font-medium text-proto-ink transition-colors duration-150 hover:border-proto-accent disabled:cursor-not-allowed disabled:opacity-45 disabled:hover:border-proto-line" data-id="element-444" data-mp="15wby7qpg4mvx">
            <Icon className="h-3.5 w-3.5 text-proto-muted" aria-hidden="true" data-id="element-445" data-mp="30yfd1o6wkks1" />
            {label}
          </button>)}
      </div>
    </section>;
}